import { Box, Flex, HStack, Select, Table, TableContainer, Tbody, Text, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react'
import React, { useEffect } from 'react'
import { useState } from 'react'
import ColorCode from '../Components/ColorCode'
import Pagination from '../Components/Pagination'
import Preloader from '../Components/Preloader'
import SearchComponent from '../Components/SearchComponent'
import TableRow from '../Components/TableRow'
import MainLayout from '../Layouts/Index'
import { GetAllProductBinShelf, GetAllProductShelf, ReadBinApi } from '../Utils/ApiCalls'
import Seo from '../Utils/Seo'
import { configuration } from '../Utils/config'
import BinShelfModal from '../Components/BInShelfModal'
import UpdateBinRecord from '../Components/UpdateBinRecord'

export default function ReadBinShelf() {
    const { isOpen, onOpen, onClose } = useDisclosure();




    const [PreLoader, setPreLoader] = useState(true);


    const [Data, setData] = useState([]);
    const [SingleData, setSingleData] = useState([]);
    const [UpdatedID, setUpdatedID] = useState("");
    const [SearchText, setSearchText] = useState("");
    const [CurrentPage, setCurrentPage] = useState(1);
    console.log("currentpage", CurrentPage)
    const [PostperPage, setPostperPage] = useState(configuration.sizeperpage);

    //get current post

    const indexOfLastSra = CurrentPage * PostperPage;
    const indexOfFirstSra = indexOfLastSra - PostperPage;
    const currentShelf = Data.slice(indexOfFirstSra, indexOfLastSra);
    //change page 
    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber)
    }

    const [Result, setResult] = useState([]);
    const [TotalData, setTotalData] = useState([]);
    const [StoreType, setStoreType] = useState("");
    const [OpenEditModal, setOpenEditModal] = useState(false);





    const GetAllShelf = async () => {
        let result = await GetAllProductBinShelf()

        // console.log("GetAllShelfBIn", result);

        if (result.status === true) {
            setData(result.queryresult.productshelfdetails)
            setTotalData(result.queryresult.totalproductshelfdetails)

            setPreLoader(false)

        } else {
            setPreLoader(false)
        }
    }

    console.log("Data shelf", Data)



    const ReadBin = async (id, store) => {

        try {
            const result = await ReadBinApi(id, store)

            if (result.status === true) {


                setSingleData(result.queryresult)
                onOpen()
            }

            console.log("ReadBin", result)

        } catch (e) {

        }





    }

    const updateBin = (id) => {


        let singleInfo = Data.filter((item, i) => {
            return item._id === id
        })

        setUpdatedID(singleInfo)

        setOpenEditModal(true)


    }


    const filterData = (e) => {

        setSearchText(e.target.value)

        let result = Data.filter((item) => item.productname.includes(SearchText) || item.productshelfid.includes(SearchText) || item.category?.name.includes(SearchText))

        setResult(result)

    }

    useEffect(() => {
        GetAllShelf()
    }, [isOpen, OpenEditModal]);
    return (
        <MainLayout>
            {
                PreLoader && (

                    <Preloader />
                )
            }
            <Seo title="Bin Shelf" description='EKO IMS - Bin Shelf' />
            <Flex justifyContent={"space-between"} flexWrap="wrap" fontWeight={"500"} >

                <Text textTransform="capitalize">Total Bin Cards - {TotalData}</Text>

            </Flex>


            <Flex justifyContent={"space-between"} flexWrap="wrap" alignItems={"flex-start"}>
                <Box w={["100%", "100%", "100%", "100%", "48%"]}>

                    <SearchComponent SearchText={SearchText} setSearchText={filterData} Keywords={"productName, ProductShelfId, Category,Store"} />
                </Box>

                <Box w={["100%", "100%", "100%", "100%", "48%"]}>

                    <Text mt="-10px" fontSize={""}>Filter by Store</Text>

                    <Select borderColor={"#000"} color={"#000"} placeholder='Select Store' _focus={{ borderColor: "blue.blue400" }} fontWeight={"400"} fontSize={StoreType != "" ? "16px" : "12px"} id='store' value={StoreType} onChange={(e) => setStoreType(e.target.value)}>

                        <option value="1" >Admin Store Marina</option>
                        <option value="2" >Central Circle stores, Ijora</option>
                        <option value="3" >East Circle stores, Island</option>
                        <option value="4" >West Circle stores, Festac</option>

                    </Select>
                </Box>
            </Flex>

            <Box height="70vh" minH={"70vh"} overflow="auto" _hover={{ overflow: "auto" }} bg="blue.blue300" mt="32px" rounded={"8px"}>

                <ColorCode />

                <TableContainer mt="32px" overflowX="auto" color="#fff">

                    <Table variant='simple' size='sm'>
                        <Thead>
                            <Tr >
                                <Th color="#fff">S/N</Th>
                                <Th color="#fff">Name</Th>
                                <Th color="#fff">Qty group</Th>
                                <Th color="#fff">Store</Th>
                                <Th color="#fff">Price</Th>
                                <Th color="#fff">Minimum</Th>
                                <Th color="#fff">Maximum</Th>
                                <Th color="#fff">Reorder</Th>
                                <Th color="#fff">Category</Th>
                                <Th color="#fff">Update Bin</Th>
                                <Th color="#fff">Read Bin</Th>

                            </Tr>
                        </Thead>
                        <Tbody>

                            {
                                SearchText === "" && StoreType === "" ? (
                                    currentShelf.map((item, i) => (
                                        <TableRow
                                            type="BinShelf"
                                            key={i}
                                            sn={i + 1}
                                            productName={item.productname}
                                            qty={item.qty?.toLocaleString()}
                                            qtyServiceable={item.qtyserviceable?.toLocaleString()}
                                            qtyUnserviceable={item.qtyunserviceable?.toLocaleString()}
                                            price={item.price?.toLocaleString()}
                                            minimum={item.minimum?.toLocaleString()}
                                            maximum={item.maximum?.toLocaleString()}
                                            reorder={item.reorder?.toLocaleString()}
                                            store={item.store}
                                            category={item.category?.name}
                                            onClick={() => ReadBin(item.productshelfid, item?.store)}
                                            update={() => updateBin(item._id)}


                                        />
                                    ))
                                ) : (
                                    SearchText !== "" && Data.filter(item => item.productname.toLowerCase().includes(SearchText.toLowerCase()) || item.productshelfid.includes(SearchText) || item.category?.name.toLowerCase().includes(SearchText.toLowerCase())).length > 0 ? (
                                        Data.filter(item => item.productname.toLowerCase().includes(SearchText.toLowerCase()) || item.productshelfid.includes(SearchText) || item.category?.name.toLowerCase().includes(SearchText.toLowerCase()) || item.store === StoreType)
                                            .map((item, i) => (
                                                <TableRow
                                                    type="BinShelf"
                                                    key={i}
                                                    sn={i + 1}
                                                    productName={item.productname}
                                                    id={item.productshelfid}
                                                    qty={item.qty}
                                                    qtyServiceable={item.qtyserviceable}
                                                    qtyUnserviceable={item.qtyunserviceable}
                                                    price={item.price}
                                                    minimum={item.minimum?.toLocaleString()}
                                                    maximum={item.maximum?.toLocaleString()}
                                                    reorder={item.reorder?.toLocaleString()}
                                                    store={item?.store}
                                                    category={item.category?.name}
                                                    onClick={() => ReadBin(item.productshelfid, item?.store)}
                                                    update={() => updateBin(item._id)}

                                                />
                                            ))
                                    ) : (

                                        StoreType !== "" ? (
                                            Data.filter(item => item.store === StoreType)
                                                .map((item, i) => (
                                                    <TableRow
                                                        type="BinShelf"
                                                        key={i}
                                                        sn={i + 1}
                                                        productName={item.productname}
                                                        id={item.productshelfid}
                                                        qty={item.qty}
                                                        qtyServiceable={item.qtyserviceable}
                                                        qtyUnserviceable={item.qtyunserviceable}
                                                        price={item.price}
                                                        minimum={item.minimum?.toLocaleString()}
                                                        maximum={item.maximum?.toLocaleString()}
                                                        reorder={item.reorder?.toLocaleString()}
                                                        store={item?.store}
                                                        category={item.category?.name}
                                                        onClick={() => ReadBin(item.productshelfid, item?.store)}
                                                        update={() => updateBin(item._id)}

                                                    />
                                                ))
                                        ) : (

                                            <Text textAlign={"right"} mt="32px" color="#ddd">*--No result found--*</Text>
                                        )

                                    )
                                )

                            }

                        </Tbody>

                    </Table>
                </TableContainer>

                <Pagination postPerpage={PostperPage} currentPage={CurrentPage} totalPosts={Data.length} paginate={paginate} />

            </Box>

            <BinShelfModal onClose={onClose} onOpen={onOpen} isOpen={isOpen} singleData={SingleData} />
            <UpdateBinRecord onClose={() => setOpenEditModal(false)} isOpen={OpenEditModal} updatedPayload={UpdatedID} />
        </MainLayout>
    )
}
